import MobileAppModal from './MobileAppModal';

export default {
  MobileAppModal,
};
